module.exports = __webpack_public_path__ + "static/media/DELTA_logo2.ca885352.jpg";